import axios from "axios";
import { BaseUrl } from "./BaseUrl";

const ApiRequest = async (method, endpoint, payload = {}, options = {}) => {
  const defaultHeaders = {
    "x-access-token": localStorage.getItem("accessToken"),
  };

  const mergedHeaders = {
    ...defaultHeaders,
    ...(options.headers || {}),
  };
  try {
    let response = null;
    switch (method) {
      case "POST":
        response = await axios.post(BaseUrl + endpoint, payload, { headers: mergedHeaders });
        break;

      case "GET":
        response = await axios.get(BaseUrl + endpoint, { headers: mergedHeaders });
        break;

      // case "PUT":
      //   response = await axios.put(BaseUrl + endpoint, payload, headers);
      //   break;

      // case "DELETE":
      //   response = await axios.delete(BaseUrl + endpoint, payload, headers.headers);
      //   break;

      default:
        // throw new Error(`Invalid method: ${method}`);
    }
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default ApiRequest;
